/**
 * Adapts this app's `useTranslation("jobOffer")` i18n to the `labels` prop
 * shape `@/scoringUi` components expect (see labels.default.js in
 * the package). `react` (the admin panel) has no i18next, so it just uses
 * the package's baked-in Polish defaults -- this adapter exists only for
 * cyberjob_client, which is PL/EN/DE trilingual.
 */
export function buildScoringLabels(t) {
    return {
        sectionTitle: t("scoringUi.sectionTitle"),
        scoringEnabled: t("scoringUi.scoringEnabled"),
        summaryEnabled: t("scoringUi.summaryEnabled"),
        summaryDisabled: t("scoringUi.summaryDisabled"),
        summaryMax: (max) => t("scoringUi.summaryMax", { max }),
        maxScore: t("scoringUi.maxScore"),
        description: t("scoringUi.description"),
        missingPolicy: t("scoringUi.missingPolicy"),
        missingPolicyOptions: t("scoringUi.missingPolicyOptions", { returnObjects: true }),
        scoringType: t("scoringUi.scoringType"),
        scoringTypeOptions: t("scoringUi.scoringTypeOptions", { returnObjects: true }),
        disqualify: t("scoringUi.disqualify"),
        valueRulesTitle: t("scoringUi.valueRulesTitle"),
        valueColumn: t("scoringUi.valueColumn"),
        pointsColumn: t("scoringUi.pointsColumn"),
        disqualifyColumn: t("scoringUi.disqualifyColumn"),
        addValueRule: t("scoringUi.addValueRule"),
        rangeFrom: t("scoringUi.rangeFrom"),
        rangeTo: t("scoringUi.rangeTo"),
        addRangeRule: t("scoringUi.addRangeRule"),
        rangeOverlapError: t("scoringUi.rangeOverlapError"),
        setAggregation: t("scoringUi.setAggregation"),
        setAggregationOptions: t("scoringUi.setAggregationOptions", { returnObjects: true }),
        capAtMaxScore: t("scoringUi.capAtMaxScore"),
        addSetRule: t("scoringUi.addSetRule"),
        aiCriterion: t("scoringUi.aiCriterion"),
        aiCriterionPlaceholder: t("scoringUi.aiCriterionPlaceholder"),
        aiLevelsTitle: t("scoringUi.aiLevelsTitle"),
        aiLevelColumn: t("scoringUi.aiLevelColumn"),
        aiLevelOptions: t("scoringUi.aiLevelOptions", { returnObjects: true }),
        addAiLevel: t("scoringUi.addAiLevel"),
        remove: t("scoringUi.remove"),
        sourceScenario: t("scoringUi.sourceScenario"),
        sourceScenarioLocked: t("scoringUi.sourceScenarioLocked"),
        sourceRecruitment: t("scoringUi.sourceRecruitment"),
        customizeForRecruitment: t("scoringUi.customizeForRecruitment"),
        noEvaluation: t("scoringUi.noEvaluation"),
        bucketRecommended: t("scoringUi.bucketRecommended"),
        bucketToReview: t("scoringUi.bucketToReview"),
        bucketLow: t("scoringUi.bucketLow"),
        bucketVeryLow: t("scoringUi.bucketVeryLow"),
        bucketDisqualified: t("scoringUi.bucketDisqualified"),
        bucketNeedsReview: t("scoringUi.bucketNeedsReview"),
    };
}
